import React from "react";

export default function DeviceSettingsModal({
  showDeviceSettings, closeDeviceSettings, saveDeviceSettings,
  isLoadingDevices,
  selectedCamera, setSelectedCamera, availableCameras, startCamera,
  cameraError, videoRef,
  selectedMicrophone, setSelectedMicrophone, availableMicrophones, startMicrophone,
  microphoneLevel,
}) {
  if (!showDeviceSettings) return null;

  return (
    <div className="device-settings-modal-overlay">
      <div className="device-settings-modal">
        <div className="device-settings-header">
          <h2>Video Settings</h2>
          <button className="close-btn" onClick={closeDeviceSettings}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="device-settings-content">
          {isLoadingDevices ? (
            <div className="device-loading">
              <div className="loading-spinner"></div>
              <p>Загрузка устройств...</p>
            </div>
          ) : (
            <>
              {/* Camera Section */}
              <div className="device-section">
                <div className="device-label">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="12" cy="13" r="4" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  Camera
                </div>
                <select
                  className="device-select"
                  value={selectedCamera}
                  onChange={(e) => {
                    setSelectedCamera(e.target.value);
                    startCamera(e.target.value);
                  }}
                >
                  {availableCameras.map(camera => (
                    <option key={camera.deviceId} value={camera.deviceId}>
                      {camera.label || `Camera ${camera.deviceId.slice(0, 8)}`}
                    </option>
                  ))}
                </select>
              </div>

              {/* Camera Preview */}
              <div className="device-section">
                <div className="camera-preview-container">
                  {cameraError ? (
                    <div className="camera-error">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                        <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" strokeWidth="2"/>
                        <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                      <p>Ошибка камеры: {cameraError}</p>
                    </div>
                  ) : (
                    <video
                      ref={videoRef}
                      className="camera-preview"
                      autoPlay
                      playsInline
                      muted
                      onLoadedMetadata={() => console.log('Video metadata loaded')}
                      onError={(e) => console.error('Video error:', e)}
                    />
                  )}
                </div>
              </div>

              {/* Microphone Section */}
              <div className="device-section">
                <div className="device-label">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M19 10v2a7 7 0 0 1-14 0v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="12" y1="19" x2="12" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="8" y1="23" x2="16" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Microphone
                </div>
                <select
                  className="device-select"
                  value={selectedMicrophone}
                  onChange={(e) => {
                    setSelectedMicrophone(e.target.value);
                    startMicrophone(e.target.value);
                  }}
                >
                  {availableMicrophones.map(mic => (
                    <option key={mic.deviceId} value={mic.deviceId}>
                      {mic.label || `Microphone ${mic.deviceId.slice(0, 8)}`}
                    </option>
                  ))}
                </select>
              </div>

              {/* Microphone Level Indicator */}
              <div className="device-section">
                <div className="microphone-level-container">
                  <div className="microphone-level-label">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Уровень звука: {microphoneLevel}%
                  </div>
                  <div className="microphone-level-bar">
                    <div
                      className="microphone-level-fill"
                      style={{ width: `${microphoneLevel}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="device-settings-footer">
          <button className="cancel-btn" onClick={closeDeviceSettings}>
            Cancel
          </button>
          <button className="save-btn" onClick={saveDeviceSettings}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
